<template>
  <ModalComponent
    ref="modalRef"
    submitButtonText="Close"
    :hideSubmitButton="true"
    @close="$emit('close')"
  >
    <template #title>
      <span class="cg-micro d-block">Lineage · {{ lot }}</span>
      Lot to evidence
    </template>
    <template #body>
      <table class="table table-sm mb-0 cg-key-table">
        <tbody>
          <tr v-for="row in rows" :key="row.k">
            <td class="text-body-secondary">{{ row.k }}</td>
            <td>{{ row.v }}</td>
          </tr>
        </tbody>
      </table>
    </template>
  </ModalComponent>
</template>

<script setup lang="ts">
import type { KeyValue } from "@/compliance_groups/fixture/complianceGroupsTypes";
import ModalComponent from "@/components/common/ModalComponent.vue";
import { onMounted, useTemplateRef } from "vue";

defineProps<{ rows: KeyValue[]; lot: string }>();
defineEmits<{ close: [] }>();
const modalRef =
  useTemplateRef<InstanceType<typeof ModalComponent>>("modalRef");
onMounted(() => modalRef.value?.toggleModal());
</script>
